export default __webpack_public_path__ + "static/media/Scarclaw Hauberk.38c47afd.jpg";